
import styled from 'styled-components';


export const StylableDiv = styled.div(props => props)
